
{
  "familyId": "GET-BREUK-GEMENGD",
  "questions": [
    {
      "id": "GET-BREUK-GEMENGD-001",
      "familyId": "GET-BREUK-GEMENGD",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_gemengd",
      "questionType": "multiple_choice",
      "question": "Een bakker heeft ⁷⁄₃ taart over. Schrijf dit als gemengd getal.",
      "options": ["2⅓", "1⅓", "2⅔", "3½"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": { "title": "Onechte breuk → gemengd getal", "content": "Deel de teller door de noemer. 7 ÷ 3 = 2 rest 1. Het hele getal is 2, de rest wordt de nieuwe teller: ⁷⁄₃ = 2⅓.", "icon": "lightbulb" }
        }
      ],
      "conceptId": "breuk_naar_gemengd",
      "variantIndex": 1,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Deel de teller door de noemer om een onechte breuk om te zetten naar een gemengd getal. 7 ÷ 3 = 2 rest 1. Het hele getal is 2 (het quotiënt), de rest is 1 → breukdeel = ⅓. Dus ⁷⁄₃ = 2⅓. Controleer: 2 × 3 + 1 = 7 ✓.",
        "solutionSteps": [
          "Deel de teller door de noemer: 7 ÷ 3 = 2 rest 1",
          "Het hele getal = 2 (het quotiënt)",
          "De rest = 1 → breukdeel = ⅓",
          "⁷⁄₃ = 2⅓",
          "Controleer: 2 × 3 + 1 = 7 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 7 ÷ 3 = 2 rest 1, dus ⁷⁄₃ = 2⅓.",
          "1": "Je dacht waarschijnlijk dat 3 maar 1 keer in 7 past. Maar 3 × 2 = 6, dus 3 past 2 keer in 7 (niet 1 keer). Onthoud: deel de teller door de noemer en tel hoe vaak de noemer erin past.",
          "2": "Je dacht waarschijnlijk dat de rest 2 is. Maar 7 − 6 = 1 (rest), niet 2. Het breukdeel is dus ⅓, niet ⅔. Onthoud: de rest is het verschil tussen de teller en het product van quotiënt × noemer.",
          "3": "Je dacht waarschijnlijk dat de noemer 2 is. Maar ⁷⁄₃ heeft noemer 3, niet 2. 3½ = ⁷⁄₂, niet ⁷⁄₃. Onthoud: de noemer van het gemengde getal blijft dezelfde als de oorspronkelijke noemer."
        }
      }
    },
    {
      "id": "GET-BREUK-GEMENGD-002",
      "familyId": "GET-BREUK-GEMENGD",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_gemengd",
      "questionType": "multiple_choice",
      "question": "Een timmerman heeft 3¼ meter plank nodig. Schrijf dit als onechte breuk.",
      "options": ["¹³⁄₄", "¹²⁄₄", "⁷⁄₄", "³¹⁄₄"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": { "title": "Gemengd getal → onechte breuk", "content": "Vermenigvuldig het hele getal met de noemer en tel de teller erbij op. 3 × 4 = 12, dan 12 + 1 = 13. De noemer blijft 4. Dus 3¼ = ¹³⁄₄.", "icon": "lightbulb" }
        }
      ],
      "conceptId": "gemengd_naar_breuk",
      "variantIndex": 2,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Vermenigvuldig het hele getal met de noemer en tel de teller erbij op. 3 × 4 = 12, dan 12 + 1 = 13. De noemer blijft 4. Dus 3¼ = ¹³⁄₄.",
        "solutionSteps": [
          "Heel getal × noemer: 3 × 4 = 12",
          "Tel de teller erbij: 12 + 1 = 13",
          "De noemer blijft 4",
          "3¼ = ¹³⁄₄"
        ],
        "distractorExplanations": {
          "0": "Goed! 3 × 4 + 1 = 13, dus 3¼ = ¹³⁄₄.",
          "1": "Je dacht waarschijnlijk dat je alleen het hele getal met de noemer vermenigvuldigt. 3 × 4 = 12, maar je moet de teller (1) er nog bij optellen: 12 + 1 = 13. Onthoud: de formule is heel × noemer + teller.",
          "2": "Je dacht waarschijnlijk dat je het hele getal en de noemer optelt. 3 + 4 = 7, maar de formule is: heel × noemer + teller = 3 × 4 + 1 = 13. Onthoud: vermenigvuldigen, niet optellen.",
          "3": "Je dacht waarschijnlijk dat je de cijfers achter elkaar schrijft. 3¼ is niet 31 vierde. De formule is: 3 × 4 + 1 = 13 → ¹³⁄₄. Onthoud: reken altijd uit met de formule."
        }
      }
    },
    {
      "id": "GET-BREUK-GEMENGD-003",
      "familyId": "GET-BREUK-GEMENGD",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_gemengd",
      "questionType": "multiple_choice",
      "question": "Een apotheker mengt 1¾ liter siroop met 2½ liter water. Hoeveel liter is het totaal?",
      "options": ["4¼", "3¾", "3⁵⁄₆", "4¾"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": { "title": "Gemengde getallen optellen", "content": "Tel de hele getallen apart op en de breuken apart. Maak de breuken eerst gelijknamig. 1 + 2 = 3. ¾ + ½ = ¾ + ²⁄₄ = ⁵⁄₄ = 1¼. Totaal: 3 + 1¼ = 4¼.", "icon": "lightbulb" }
        }
      ],
      "conceptId": "gemengd_optellen",
      "variantIndex": 3,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Tel de hele getallen en de breuken apart op. Hele getallen: 1 + 2 = 3. Breuken gelijknamig maken: ¾ + ½ = ¾ + ²⁄₄ = ⁵⁄₄. Omdat ⁵⁄₄ = 1¼ (onechte breuk → gemengd), tel je die extra 1 bij de hele getallen: 3 + 1¼ = 4¼.",
        "solutionSteps": [
          "Hele getallen optellen: 1 + 2 = 3",
          "Breuken gelijknamig maken: ¾ + ½ = ¾ + ²⁄₄",
          "Breuken optellen: ¾ + ²⁄₄ = ⁵⁄₄",
          "Onechte breuk omzetten: ⁵⁄₄ = 1¼",
          "Totaal: 3 + 1¼ = 4¼"
        ],
        "distractorExplanations": {
          "0": "Goed! 1¾ + 2½ = 3 + ¾ + ²⁄₄ = 3 + ⁵⁄₄ = 3 + 1¼ = 4¼.",
          "1": "Je dacht waarschijnlijk dat ⁵⁄₄ gewoon ¾ is. Maar ⁵⁄₄ = 1¼, en die extra 1 moet bij de hele getallen: 3 + 1 = 4. Onthoud: als de teller groter is dan de noemer, heb je een onechte breuk die je moet omzetten.",
          "2": "Je dacht waarschijnlijk dat je de noemers optelt. ¾ + ½ ≠ ⁵⁄₆. Je moet de breuken eerst gelijknamig maken: ¾ + ²⁄₄ = ⁵⁄₄. Onthoud: bij het optellen van breuken maak je de noemers gelijk, je telt ze niet op.",
          "3": "Je dacht waarschijnlijk dat ¾ + ²⁄₄ = ¾ blijft. Maar ¾ + ²⁄₄ = ⁵⁄₄ = 1¼, niet ¾. Het antwoord is 4¼, niet 4¾. Onthoud: tel de tellers op na gelijknamig maken."
        }
      }
    },
    {
      "id": "GET-BREUK-GEMENGD-004",
      "familyId": "GET-BREUK-GEMENGD",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_gemengd",
      "questionType": "multiple_choice",
      "question": "Een bouwmarktmedewerker ziet dat een plank 2,75 meter lang is. Welk gemengd getal is gelijk aan 2,75?",
      "options": ["2¾", "2⅞", "2⁷⁄₁₀", "2½"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule", "showWhen": "wrong",
          "data": { "title": "Decimaal → gemengd getal", "content": "Zet het decimale deel om naar een breuk. 0,75 = 75/100. Vereenvoudig: 75/100 ÷ 25/25 = ¾. Dus 2,75 = 2¾.", "icon": "lightbulb" }
        }
      ],
      "conceptId": "gemengd_decimaal_koppeling",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Zet het decimale deel om naar een breuk en vereenvoudig. 2,75 = 2 + 0,75. Dan: 0,75 = 75/100. Vereenvoudig door beide door 25 te delen: 75/100 = ¾. Dus 2,75 = 2¾.",
        "solutionSteps": [
          "Splits het getal: 2,75 = 2 + 0,75",
          "Zet 0,75 om naar een breuk: 0,75 = 75/100",
          "Vereenvoudig: 75 ÷ 25 = 3, 100 ÷ 25 = 4 → ¾",
          "2,75 = 2¾"
        ],
        "distractorExplanations": {
          "0": "Goed! 2,75 = 2¾. Want 0,75 = 75/100 = ¾.",
          "1": "Je dacht waarschijnlijk dat 0,75 = ⅞. Maar ⅞ = 0,875, niet 0,75. Onthoud: reken de breuk na door teller ÷ noemer: 7 ÷ 8 = 0,875.",
          "2": "Je dacht waarschijnlijk dat 0,75 = ⁷⁄₁₀. Maar ⁷⁄₁₀ = 0,7, niet 0,75. Onthoud: 0,75 heeft twee decimalen, dus het is 75/100 = ¾.",
          "3": "Je dacht waarschijnlijk dat 0,75 = ½. Maar ½ = 0,5, niet 0,75. Onthoud: ½ = 0,50 en ¾ = 0,75."
        }
      }
    }
  ]
}
